import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function Fleet() {
  const [fleet, setFleet] = useState([]);
  useEffect(() => { api.get("/fleet-categories?active_only=true").then((r) => setFleet(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-[var(--lt-bg)]">
      <section className="py-20 border-b border-[var(--lt-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">// Our Fleet</div>
          <h1 className="font-display font-black text-5xl md:text-6xl text-white uppercase leading-none">Equipment That Delivers.</h1>
          <p className="text-slate-400 mt-5 max-w-2xl text-lg">The Lucas Trans Inc. fleet is built around dependable equipment. Below is the equipment we currently operate.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {fleet.map((f, i) => (
            <div key={f.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`fleet-detail-${f.slug}`}>
              <div className="relative h-[380px] overflow-hidden border border-[var(--lt-border)]">
                <img src={f.image_url} alt={f.name} className="absolute inset-0 w-full h-full object-cover" />
              </div>
              <div>
                <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)]">// Equipment {String(i + 1).padStart(2, "0")}</div>
                <h2 className="font-display font-black text-4xl md:text-5xl text-white uppercase mt-2 leading-none">{f.name}</h2>
                <p className="text-slate-400 mt-4 leading-relaxed">{f.description}</p>
                {f.typical_freight && <div className="mt-5 border-l-2 border-[var(--lt-accent)] pl-4"><div className="text-xs font-mono-lt uppercase tracking-[0.2em] text-slate-500">Typical Freight</div><div className="text-white mt-1">{f.typical_freight}</div></div>}
                <Link to="/quote"><Button className="mt-7 bg-[var(--lt-accent)] hover:bg-[var(--lt-accent-hover)] text-white h-11 px-6 rounded-xl font-head uppercase tracking-widest text-xs">Get a Quote</Button></Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
